import * as YDate from 'yup';
import { code } from '../code';
import { calendar } from '../calendar';
import { T, translate } from '../text';

declare module 'yup' {
    interface DateSchema {
        validDate(date?: Date, errorMessage?: string): this;
        greaterThanDate(date?: Date, errorMessage?: string): this;
        greaterThanEqualDate(date?: Date, errorMessage?: string): this;
        lessThanDate(date?: Date, errorMessage?: string): this;
        lessThanEqualDate(date?: Date, errorMessage?: string): this;
    }
}

//-- date custom functions
YDate.addMethod(YDate.date, 'validDate', function (errorMessage) {
    if (!errorMessage) errorMessage = 'invalid-date';
    return this.test('validDate', errorMessage, function (value) {
        if (!value) return false;
        return calendar.isValid(value);
    });
});

YDate.addMethod(YDate.date, 'greaterThanDate', function (fromDate, errorMessage) {
    if (!errorMessage)
        errorMessage = (
            <T date={calendar.dateToString(fromDate)}>must-be-greater-than-from-@date</T>
        );
    return this.test(`greaterThanDate`, errorMessage, function (value) {
        if (!value) return true;
        return calendar.dateToString(value) > calendar.dateToString(fromDate);
    });
});

YDate.addMethod(YDate.date, 'greaterThanEqualDate', function (fromDate, errorMessage) {
    if (!errorMessage)
        errorMessage = (
            <T date={calendar.dateToString(fromDate)}>must-be-greater-than-equal-from-@date</T>
        );
    return this.test(`greaterThanEqualDate`, errorMessage, function (value) {
        if (!value) return true;
        return calendar.dateToString(value) >= calendar.dateToString(fromDate);
    });
});

YDate.addMethod(YDate.date, 'lessThanDate', function (toDate, errorMessage) {
    if (!errorMessage)
        errorMessage = <T date={calendar.dateToString(toDate)}>must-be-less-than-from-@date</T>;
    return this.test(`lessThanDate`, errorMessage, function (value) {
        if (!value) return true;
        return calendar.dateToString(value) < calendar.dateToString(toDate);
    });
});

YDate.addMethod(YDate.date, 'lessThanEqualDate', function (toDate, errorMessage) {
    if (!errorMessage)
        errorMessage = (
            <T date={calendar.dateToString(toDate)}>must-be-less-than-equal-from-@date</T>
        );
    return this.test(`lessThanEqualDate`, errorMessage, function (value) {
        if (!value) return true;
        return calendar.dateToString(value) <= calendar.dateToString(toDate);
    });
});

export { YDate };
